import * as Scrivito from "scrivito";
import defaultSocialHeaderButtonEditingConfig from "../_defaultSocialHeaderButtonEditingConfig";

Scrivito.provideEditingConfig(
  "XingSocialHeaderButton",
  defaultSocialHeaderButtonEditingConfig,
);
